/**
 * 验证流程模式管理模块
 * 统一管理所有验证码相关的流程模式和 templateCode 映射
 */

// 验证流程类型枚举
const VerificationType = {
  REGISTER: 'register',                          // 注册
  VERIFY_CURRENT_EMAIL: 'verify-current-email',  // 验证当前邮箱（修改邮箱第一步）
  VERIFY_NEW_EMAIL: 'verify-new-email',          // 验证新邮箱（修改邮箱第二步）
  ADD_PASSWORD: 'add-password',                  // 添加密码
  CHANGE_PASSWORD: 'change-password',            // 修改密码
  RESET_PASSWORD: 'reset-password',              // 重置密码
  DELETE_ACCOUNT: 'delete-account'               // 注销账户
};

// 导出给全局使用
window.VerificationType = VerificationType;

// templateCode 映射表 (1=注册, 2=修改密码, 3=登陆后重置密码, 4=注销, 5=修改邮箱)
const TEMPLATE_CODE_MAP = {
  'register': 1,
  'verify-current-email': 5,
  'verify-new-email': 5,
  'add-password': 3,
  'change-password': 3,
  'reset-password': 2,
  'delete-account': 4
};

/**
 * 根据验证类型获取对应的 templateCode
 * @param {string} verificationType - 验证类型
 * @returns {number} templateCode
 */
function getTemplateCode(verificationType) {
  const code = TEMPLATE_CODE_MAP[verificationType];
  if (!code) {
    console.warn(`Unknown verification type: ${verificationType}, using default templateCode: 1`);
    return 1;
  }
  return code;
}

// 导出给全局使用
window.getTemplateCode = getTemplateCode;

/**
 * 设置验证类型到 sessionStorage
 * @param {string} verificationType - 验证类型
 * @returns {boolean} 是否设置成功
 */
function setVerificationType(verificationType) {
  if (!Object.values(VerificationType).includes(verificationType)) {
    console.error(`Invalid verification type: ${verificationType}`);
    return false;
  }
  
  sessionStorage.setItem('verificationType', verificationType);
  return true;
}

// 导出给全局使用
window.setVerificationType = setVerificationType;

/**
 * 获取当前验证类型
 * @returns {string|null} 当前验证类型
 */
function getVerificationType() {
  return sessionStorage.getItem('verificationType');
}

// 导出给全局使用
window.getVerificationType = getVerificationType;

/**
 * 清除验证类型
 */
function clearVerificationType() {
  sessionStorage.removeItem('verificationType');
}

// 导出给全局使用
window.clearVerificationType = clearVerificationType;

/**
 * 根据验证类型获取验证成功后的跳转 URL
 * @param {string} verificationType - 验证类型
 * @returns {string} 跳转 URL
 */
function getRedirectUrlAfterVerification(verificationType) {
  const isMobile = window.innerWidth <= 734;
  
  const urlMap = {
    'verify-current-email': '/pages/setup-email',                          // 验证当前邮箱后 → 输入新邮箱
    'verify-new-email': isMobile ? '/pages/account-security' : '/pages/my-account',  // 验证新邮箱后 → 账户页面
    'add-password': '/pages/setup-password',                               // 验证成功后 → 设置密码
    'change-password': '/pages/setup-password',                            // 验证成功后 → 设置新密码
    'reset-password': '/pages/reset-password',                             // 验证成功后 → 重置密码
    'delete-account': '/pages/account-deleted',                            // 验证成功后 → 注销确认页
    'register': '/pages/register'                                          // 注册验证后继续注册流程
  };
  
  return window.withSitePrefix ? window.withSitePrefix(urlMap[verificationType] || '/') : urlMap[verificationType] || '/';
}

// 导出给全局使用
window.getRedirectUrlAfterVerification = getRedirectUrlAfterVerification;

/**
 * 检查验证类型是否需要更新用户资料
 * @param {string} verificationType - 验证类型
 * @returns {boolean}
 */
function shouldUpdateUserProfile(verificationType) {
  return verificationType === VerificationType.VERIFY_NEW_EMAIL;
}

// 导出给全局使用
window.shouldUpdateUserProfile = shouldUpdateUserProfile;

/**
 * 检查验证类型是否需要注销账户
 * @param {string} verificationType - 验证类型
 * @returns {boolean}
 */
function shouldDeleteAccount(verificationType) {
  return verificationType === VerificationType.DELETE_ACCOUNT;
}

// 导出给全局使用
window.shouldDeleteAccount = shouldDeleteAccount;

// Verification Mode module loaded

